export default __webpack_public_path__ + "20efc3a1bbfbaecb58d960965d2a480e.png";